import { accountsModuleI18n } from "@/modules/accounts";
import { authModuleI18n } from "@/modules/auth";
import { organizationModuleI18n } from "@/modules/organization";
import { partnersModuleI18n } from "@/modules/partners";
import { shopModuleI18n } from "@/modules/shop";
import { commonModuleI18n } from "@/modules/common";
import { eventsModuleI18n } from "@/modules/events";
import { consultantModuleI18n } from "@/modules/consultant";
import { NFTsModuleI18n } from "@/modules/NFT";
import { dataModuleI18n } from "@/modules/data";
import { errorModuleI18n } from "@/modules/error";
import { profileModuleI18n } from "@/modules/profile";
import { projectsModuleI18n } from "@/modules/projects";
import { userModuleI18n } from "@/modules/user";
import { webModuleI18n } from "@/modules/web";
import { servicesModuleI18n } from "@/modules/services";
import { blogModuleI18n } from "@/modules/blog";
import { trainingModuleI18n } from "@/modules/training";

export const es = {
  auth: authModuleI18n.es,
  shop: shopModuleI18n.es,
  accounts: accountsModuleI18n.es,
  partners: partnersModuleI18n.es,
  organization: organizationModuleI18n.es,
  common: commonModuleI18n.es,
  events: eventsModuleI18n.es,
  consultant: consultantModuleI18n.es,
  data: dataModuleI18n.es,
  error: errorModuleI18n.es,
  profile: profileModuleI18n.es,
  projects: projectsModuleI18n.es,
  user: userModuleI18n.es,
  web: webModuleI18n.es,
  NFTs: NFTsModuleI18n.es,
  services: servicesModuleI18n.es,
  blog: blogModuleI18n.es,
  training: trainingModuleI18n.es
};
